import React, { useContext, useEffect } from 'react';
import { ProductContext } from './ProductContext';
import { useParams } from 'react-router-dom';

import './Display.css';

const Display = () => {
  const {
    selectedProductId,
    setSelectedProductId,
    selectedProduct,
    loading,
    products,
  } = useContext(ProductContext);
  const { productId } = useParams();

  useEffect(() => {
    // If we came from a URL with /id/:productId, set it
    //Removed the check box
    if (productId && productId !== selectedProductId) {
      const exists = products.find(p => p.p_Id.toString() === productId);
      if (exists) {
        setSelectedProductId(productId);
      }
    }
  }, [productId, selectedProductId, products, setSelectedProductId]);

  useEffect(() => {
    console.log('Display updated. Current product:', selectedProduct?.p_Name);
  }, [selectedProduct]);

  if (loading) return <div>Loading...</div>;
  if (!selectedProduct) return <div>No product found!</div>;

  return (
    <div className="display-container" key={selectedProduct.p_Id}>
      <div className="display-video">
        {selectedProduct.p_HeroVideo ? (
          <video
            className="display-video-inside"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={selectedProduct.p_HeroVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img
            className="display-video-inside"
            src={selectedProduct.p_HeroImage}
            alt={selectedProduct.p_Name}
          />
        )}
      </div>

      <div className="display-data">
        <h2>{selectedProduct.p_Name}</h2>
        {[1, 2, 3, 4].map(i => {
          const line = selectedProduct[`p_line0${i}`];
          return line ? <p key={i}>{line}</p> : null;
        })}

        {/* Passive disclaimer instead of checkbox */}
        {selectedProduct.p_line99 && (
          <p className="terms-note">{selectedProduct.p_line99}</p>
        )}

        {selectedProduct.p_Link && (
          <a
            href={selectedProduct.p_Link}
            className="product-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button>{selectedProduct.p_line04 || 'Buy Now'}</button>
          </a>
        )}
      </div>
    </div>
  );
};

export default Display;
